import { createAsyncThunk } from "@reduxjs/toolkit";
import { IOrder } from "../../../helpers/types";
import OrdersService from "../../../api/OrdersService";

export const asyncGetOrdersAction = createAsyncThunk(
    'orders/all',
    async (query: any, thunkAPI) => {
        try {
            let response = await OrdersService.findAll(query);
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message)
        }
    }
);

export const asyncGetOrderAction = createAsyncThunk(
    'orders/one',
    async (id: number, thunkAPI) => {
        try {
            let response = await OrdersService.findOne(id);
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message)
        }
    }
);

export const asyncUpdateOrderAction = createAsyncThunk(
    'orders/update',
    async (order: any, thunkAPI) => {
        try {
            const { id, ...orderData } = order;

            let response = await OrdersService.update(orderData, id as number);
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message)
        }
    }
);

export const asyncGetGlobalUnreadCountAction = createAsyncThunk(
    'orders/getGlobalUnreadCount',
    async (_, thunkAPI) => {
        try {
            const response = await OrdersService.getGlobalUnreadCount();
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message || 'Error fetching unread count');
        }
    }
);

export const asyncDeleteOrderAction = createAsyncThunk(
    'orders/delete',
    async (id: number, thunkAPI) => {
        try {
            let response = await OrdersService.delete(id);
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message)
        }
    }
);